export class UmbracoUtility {
  static getCMSContentUrl(contentId: number): string {
    return `/umbraco#/content/content/edit/${contentId}`;
  }
}
